export default {"src":"/_next/static/media/quickstart.9671b81b.svg","height":256,"width":362,"blurWidth":0,"blurHeight":0};